module.exports = __webpack_public_path__ + "img/d201211-3.f206a6e3.jpg";